import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { tokenExists } from '../api/auth';
import useCurrentUser from '../hooks/useCurrentUser';
import { hasAnyPermission, hasPermission } from '../utils/permissions';

const RequirePermission = ({ permissions = [], children }) => {
  const location = useLocation();
  const { user, status } = useCurrentUser();

  if (!tokenExists()) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (status === 'loading' || status === 'idle') return null;
  if (status === 'unauthorized') {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!permissions.length) return children;

  if (!hasAnyPermission(user, permissions)) {
    const fallback = hasPermission(user, 'branch.read') ? '/branches' : '/home';
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default RequirePermission;
